import { useChatStore } from '@/state/chatState';
import { useChatUIStore } from '@/state/chatUiState';
import { QueryClient } from '@tanstack/react-query';
export function resetAllStores(queryClient: QueryClient) {
  queryClient.clear();
  useChatStore.getState().reset();
  useChatUIStore.getState().reset();
  sessionStorage.clear();
}
